<template>
  <v-container>
    <v-row v-if="fundingCampaigns.length>0"> 
      <v-carousel hide-delimiters :show-arrows-on-hover="true" :key="carouselKey">
         <template v-slot:prev="{ on, attrs }">
            <v-btn
              v-if="newAvailable"
              v-bind="attrs"
              @click="newCampaign"
            > <v-icon>mdi-plus</v-icon> </v-btn>
            <v-btn
              v-else
              v-bind="attrs"
              @click="prev"
              v-on="on"
              :disabled="prevDisable"
            > <v-icon>mdi-chevron-left</v-icon> </v-btn>
          </template>
          <template v-slot:next="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              @click="next"
              v-on="on"
              :disabled="nextDisable"
            > <v-icon>mdi-chevron-right</v-icon> </v-btn>
          </template>
        <v-carousel-item
          v-for="(item,index) in fundingCampaigns" :key="'fc'+index"
        >
          <funding-campaign :fundingCampaign="item" @newCampaign="getFundingCampaigns" />  
        </v-carousel-item>
      </v-carousel>
    </v-row>
    <v-row v-else > 
      <funding-campaign @newCampaign="getFundingCampaigns"/>
    </v-row>
  </v-container>
</template>
<script>
export default {
  components:{
    FundingCampaign:()=>import('./FundingCampaign.vue')
  },
  data(){
    return {
      fundingCampaigns:[],
      index: 0,
      carouselKey:0,
      nextDisable: false,
      prevDisable: true
    }
  },
  mounted(){
    this.getFundingCampaigns();
  },
  computed:{
    newAvailable(){
      return (this.fundingCampaigns[0].status>3 && this.index===0)?true:false
    }
  },
  watch:{
    index(){
      if(this.index === 0){
        this.prevDisable = true
        
      } else {
        this.prevDisable = false
      }
      if(this.index < this.fundingCampaigns.length-1){
        this.nextDisable = false
      } else {
        this.nextDisable = true
      }
    }
  },
  methods:{
    getFundingCampaigns(){
      this.$cf_api.getFundingCampaigns(this.$route.params.id).then(response=> {
        this.fundingCampaigns = response.data
        if(this.fundingCampaigns.length===1){
          this.nextDisable = true
        }
        this.carouselKey ++
        this.$store.commit('setFundingCampaigns',this.fundingCampaigns)
      }).catch(e=>{
        console.log('Error requesting funding campaigns for ' + this.$route.params.id +': '+e)
      })
    },
    next(){
      this.index ++
      //func()
    },
    prev(){
      this.index --
      //func()
    },
    newCampaign(){
      this.fundingCampaigns.splice(0,0,{ 
          projectId: parseInt(this.$route.params.id),
          creditsAmount: 0,
          creditsFunded: 0,
          creditPrice: 0,
          status: 0
        })
      this.carouselKey++
      this.nextDisable = false
    }
  }
}
</script>